import "./ErrorModal.css";
import { useGlobalState } from "../../Contexts/GlobalStateContext";
import { Modal, Image } from "react-bootstrap";
import Error from "../../Images/Error.png";
import Buttons from '../../Components/Buttons/Buttons';


const ErrorModal = () => {
  const { isErrorVisible, setErrorVisible, errorMessage, setVoyceToken  } = useGlobalState();
  if (!isErrorVisible) return null;
  const handleClose = () => {
    setErrorVisible(false);
    if (errorMessage === 'Requires Login') {
      setVoyceToken(null);
      window.location.reload();
    }
  }
  return (
    <Modal show={isErrorVisible} onHide={handleClose} centered scrollable className="error-modal">
      <Modal.Header className="modal-header" closeButton>
      </Modal.Header>
      <Image src={Error} className="error-image" />
      <h3 className='error-content'>Error</h3>
      <Modal.Body className="error-body">
        {errorMessage}
      </Modal.Body>
      <div></div>
      {/* <Buttons handleSubmit={handleClose}/> */}
    </Modal>
  );
};
export default ErrorModal;